import { formatGuidedFlowTemplate } from './guidedFlowUtils';

/**
 * @param {number | null | undefined} months
 * @param {typeof import('../locales/pt').default.pots.progress} copy
 */
export function formatPotMonthsRemaining(months, copy) {
  if (months == null || Number.isNaN(Number(months))) {
    return copy.monthsRemainingUnknown;
  }
  const n = Number(months);
  if (n <= 0) return copy.monthsRemainingDone;
  if (n === 1) return copy.monthsRemainingOne;
  return formatGuidedFlowTemplate(copy.monthsRemainingMany, { count: n });
}
